import {
  fetchQuestionsRequest,
  fetchQuestionsSuccess,
  fetchQuestionsFailure,
  fetchResultRequest,
  fetchResultSuccess,
  fetchResultFailure,
  //setStatus
} from "./domains";
import axios from "axios";
//import data , {result} from '../mockdata'
export const fetchQuestions = currentPage => {
  return dispatch => {
    dispatch(fetchQuestionsRequest());
    axios
      .post(
        "https://08rww5td87.execute-api.us-east-1.amazonaws.com/Prod/questions",
        {
          page: 1,
          limit: 20,
        },
        {
          headers: {
            "content-type": "application/json",
          },
        }
      )
      .then(response => {
        const { questions, total_pages: totalpages } = response.data;

        dispatch(fetchQuestionsSuccess(questions, totalpages));
      })
      .catch(error => {
        dispatch(fetchQuestionsFailure(error.message));
      });
  };
};
/* export const fetchQuestions = (currentPage) => {
    const quizdata = data();
    return (dispatch) => {

        const { cards, totalPages } = quizdata;

        dispatch(fetchQuestionsSuccess(cards, totalPages));
        
     https://08rww5td87.execute-api.us-east-1.amazonaws.com/Prod/
    };
}; */

export const fetchResult = selectedData => {
  return dispatch => {
    dispatch(fetchResultRequest());

    axios
      .post(
        "https://08rww5td87.execute-api.us-east-1.amazonaws.com/Prod/result",
        {
          charcodes: selectedData,
          page: 1,
          limit: 300,
        }
      )
      .then(response => {
        const { results: categoryList } = response.data;
        dispatch(fetchResultSuccess(categoryList));
      })
      .catch(error => {
        dispatch(fetchResultFailure(error.message));
      });
  };
};

export const fetchFeelLucky = selectedData => {
  return dispatch => {
    dispatch(fetchResultRequest());

    axios
      .post(
        "https://08rww5td87.execute-api.us-east-1.amazonaws.com/Prod/feel_lucky",
        {
          charcodes: selectedData,
          page: 1,
          limit: 20,
        }
      )
      .then(response => {
        const { results: categoryList } = response.data;
        dispatch(fetchResultSuccess(categoryList));
      })
      .catch(error => {
        dispatch(fetchResultFailure(error.message));
      });
  };
};

/* export const fetchResult = (selectedData) => {
/*     return state.questions.quizQuestionData.map(card => {
        let selected = card.choices.filter(choice => choice.selected === true)
        return selected.map(a => a.option)
    }).flat(); 
    console.log(selectedData)
    return (dispatch) => {
        const resultData = result;
        
        dispatch(fetchResultSuccess(resultData));
  
    };
}; */
